import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useInstituteService } from '../../../../apis/institute/useInstituteService';
import { IClassGradeSubjectStructureResponse } from '../../../../apis/institute/institute.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getClassGradeSubjectStructureKey = 'get-class-grade-subject-structure';

export const useClassGradeSubjectStructureHook = (
  options?: UseQueryOptions<IClassGradeSubjectStructureResponse, TQueryError>
): UseQueryResult<IClassGradeSubjectStructureResponse, TQueryError> => {
  const { getClassGradeSubjectStructure } = useInstituteService();

  return useQuery<IClassGradeSubjectStructureResponse, TQueryError>({
    queryKey: [getClassGradeSubjectStructureKey],
    queryFn: () => getClassGradeSubjectStructure(),
    enabled: true,
    ...options,
  });
};
